import type { ContentTemplate } from '@/types/stylepacks.types';
import { Get } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const GetStylepacks = () => {
  return Get<{ templates: ContentTemplate[] }>({
    host: GREENROOM_HOST,
    url: '/v2/greenroom/generate-content/templates',
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default GetStylepacks;
